import { WebsiteHeaderColors, WebsiteHeaderTextContent } from '@apps/guest/websiteHeader';
import { GetTemplatesQuery } from '@graphql/generated';
import { ImagePositionData } from './hooks/useTemplatePreviewWithUserImage/useTemplatePreviewWithUserImage.types';

/**
 * Intended to be use to set addiitional design values when user clicks on a template
 */
export type TemplateWebsiteDesignSettings = {
  colorPalette?: {
    artBackground: string;
    pageBackground: string;
    pageFont: string;
    linkAndButton: string;
    artFont: string;
  };
  pageTransparency?: boolean;
  pageShadow?: boolean;
  photoPresentationLayout?:
    | 'center'
    | 'fullWidth'
    | 'monogram'
    | 'noPhoto'
    | 'pageWidth'
    | 'photoArch'
    | 'photoBackground'
    | 'photoDuoLeft'
    | 'photoDuoRight'
    | 'photoMarquee'
    | 'photoSlider'
    | 'photoTrio'
    | 'videoBackground';
  photoBackgroundPresentationSettings?: {
    colors?: WebsiteHeaderColors;
    eventName?: Omit<WebsiteHeaderTextContent, 'content'>;
  };
  defaultHeaderPhoto?: {
    id: string;
    url: string;
    height: number;
    width: number;
  }[];
  defaultHeaderVideo?: {
    desktopVideoUrl: string;
    mobileVideoUrl?: string;
    thumbnailImageUrl?: string;
  };
  /**
   * If true, the defaultHeaderPhoto will be used as the header photo when the user selects this template.
   */
  preserveDefaultImg?: boolean;
  /**
   * If true, the defaultHeaderVideo will be used as the header video when the user selects this template.
   */
  preserveDefaultVideo?: boolean;
  jsonContainerId?: Maybe<string>;
  supportsAnimation?: boolean;
};

export type ThemeVariant = GetTemplatesQuery['themeVariants'][number] & {
  isFavorite?: boolean;
  websiteDesignSettings?: TemplateWebsiteDesignSettings;
  /**
   * Indicates hardcoded templates in our codebase, the templates that don't come from the API
   */
  isStatic?: boolean;
  hoverAnimationUrl?: string;
  transparentImageUrl?: string;
  uploadedPreviewImagePositioning?: ImagePositionData['position'];
};

export enum FilterGroupLabel {
  Layout = 'Layout',
  Collection = 'Collection',
  Categories = 'Categories',
  Colors = 'Colors',
  Photo = 'Photo',
  Animation = 'Animation',
}

export type UploadedPreviewImage = { id: string; url: string; height: number; width: number };

export enum PhotoCount {
  One = '1',
  TwoOrMore = '2+',
  Zero = '0',
}

export enum AnimationType {
  Video = 'Video',
  PhotoSlider = 'Photo Slider',
  PhotoMarquee = 'Photo Marquee',
  NoAnimation = 'No Animation',
}
